import React from 'react';
import classNames from 'classnames';
import s from './input.module.css';
const Content = ({ children, placement = 'end', onClick, pointer = false, dataTest }) => (React.createElement("span", Object.assign({}, { [`data-addon-${placement}`]: '' }, { onClick: onClick, className: classNames(s.content, s[placement], pointer && s.pointer), "data-test": dataTest }), children));
export default Content;
//# sourceMappingURL=content.js.map